/** MST = UTC-7. Next target time in Mountain as a UTC timestamp; use like fixed target. */
/** Set to 0 for midnight, or e.g. 17 for 5pm MST (testing). */
const TARGET_HOUR_MST = 0;

function getNextMidnightMountain() {
  const MST_OFFSET_MS = 7 * 60 * 60 * 1000;
  const now = Date.now();
  const mountainToday = new Date(now - MST_OFFSET_MS);
  const y = mountainToday.getUTCFullYear();
  const m = mountainToday.getUTCMonth();
  const d = mountainToday.getUTCDate();
  let targetUtc = Date.UTC(y, m, d, TARGET_HOUR_MST, 0, 0) + MST_OFFSET_MS;
  if (now >= targetUtc) targetUtc += 24 * 60 * 60 * 1000;
  return new Date(targetUtc);
}

if (!customElements.get("countdown-timer")) {
  customElements.define(
    "countdown-timer",
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();

        const isDynamic = this.dataset.timerMode === "dynamic";
        const targetDate = isDynamic
          ? getNextMidnightMountain()
          : new Date(this.dataset.targetDate);

        this.elements = {
          container: this.querySelector(".countdown-timer__date-time"),
          days: this.querySelector(".countdown-timer__days"),
          hours: this.querySelector(".countdown-timer__hours"),
          minutes: this.querySelector(".countdown-timer__minutes"),
          seconds: this.querySelector(".countdown-timer__seconds"),
          expirationMessage: this.dataset.expirationMessage,
          targetDate,
          isDynamic,
        };
        setInterval(() => {
          this.updateCountdown();
        }, 1000);
        this.updateCountdown();
      }

      updateCountdown() {
        const currentDate = new Date();
        let timeRemaining = this.elements.targetDate - currentDate;

        if (timeRemaining <= 0 && this.elements.isDynamic) {
          this.elements.targetDate = getNextMidnightMountain();
          timeRemaining = this.elements.targetDate - currentDate;
        }

        if (timeRemaining <= 0) {
          this.elements.container.innerHTML = this.elements.expirationMessage;
        } else {
          const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor(
            (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

          const formattedDays = String(days).padStart(2, "0");
          const formattedHours = String(hours).padStart(2, "0");
          const formattedMinutes = String(minutes).padStart(2, "0");
          const formattedSeconds = String(seconds).padStart(2, "0");

          if (this.elements.days?.firstChild) this.elements.days.firstChild.textContent = formattedDays;
          if (this.elements.hours?.firstChild) this.elements.hours.firstChild.textContent = formattedHours;
          if (this.elements.minutes?.firstChild) this.elements.minutes.firstChild.textContent = formattedMinutes;
          if (this.elements.seconds?.firstChild) this.elements.seconds.firstChild.textContent = formattedSeconds;
        }
      }
    }
  );
}
